import { useTheme } from "@mui/material";
import { LogOut } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ListRow } from "web_myplann/Shared/Components/ListRow";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";

type Props = {
	open: boolean;
	title: string;
	onClose: () => void;
	onRequestLeave: () => void;
};

export const ChatConversationActionsDrawer: FC<Props> = ({
	open,
	title,
	onClose,
	onRequestLeave,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<MyPlannDrawer open={open} onClose={onClose} grabber title={title}>
			<ListRow
				title={t(Resources.Chat.Leave.action)}
				icon={
					<LogOut size={theme.iconSize.md} color={theme.palette.red[500]} />
				}
				destructive
				showChevron={false}
				isLast
				onClick={onRequestLeave}
			/>
		</MyPlannDrawer>
	);
};
